import { Action } from "redux";
import { ApiActionRequest } from "../../core/action-types";

export const LAST_PAGE_TOGGLE = "lastPageToggle";

export interface LastPageToggleAction extends Action {
  type: typeof LAST_PAGE_TOGGLE;
}

export const lastPageToggle = (): LastPageToggleAction => {
  return { type: LAST_PAGE_TOGGLE };
};

export type NavAction = LastPageToggleAction | ApiActionRequest;
